import { useDispatch, useSelector } from "react-redux"
import { setShowItemDetails, setShowLoginModal } from "../features/ui/uiSlice"
import type { RootState } from "../store"

export const useReduxModal = () => {
  const dispatch = useDispatch()
  const { showItemDetails, showLoginModal } = useSelector((state: RootState) => state.ui)

  const openModal = () => {
    // You can add any global modal state logic here
    // For now, we'll just track that a modal is open
  }

  const closeModal = () => {
    // Close any open modals
    dispatch(setShowItemDetails(false))
    dispatch(setShowLoginModal(false))
  }

  const openItemDetails = () => {
    dispatch(setShowItemDetails(true))
  }

  const openLoginModal = () => {
    dispatch(setShowLoginModal(true))
  }

  return {
    openModal,
    closeModal,
    openItemDetails,
    openLoginModal,
    showItemDetails,
    showLoginModal,
  }
}
